import { render, staticRenderFns } from "./facturacion-ejercicios.vue?vue&type=template&id=bea920f2&scoped=true"
import script from "./facturacion-ejercicios.vue?vue&type=script&lang=js"
export * from "./facturacion-ejercicios.vue?vue&type=script&lang=js"
import style0 from "./facturacion-ejercicios.vue?vue&type=style&index=0&id=bea920f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea920f2",
  null
  
)

export default component.exports